import { useEffect } from 'react';
import { env } from '@/config/env';
import { useAuthStore } from '../stores/auth.store';
import { FullScreenLoader } from '@/components/feedback/FullScreenLoader';

/**
 * Neutral entry point that forwards a one-time `ticket` to the auth server,
 * which establishes the session and hands control back to this SPA. Uses
 * `location.replace` so the ticket URL doesn't linger in history.
 *
 * Crucially it first drops any session already stored in THIS browser: the SPA
 * persists tokens in localStorage, so without wiping them the app would just
 * restore the previous user on return instead of the newly-established one.
 */
export function AuthStartPage() {
  useEffect(() => {
    const ticket = new URLSearchParams(window.location.search).get('ticket');
    if (!ticket) {
      window.location.replace('/login');
      return;
    }
    try {
      useAuthStore.getState().clear();
    } catch {
      /* ignore */
    }
    try {
      localStorage.removeItem('gral.auth');
    } catch {
      /* ignore */
    }
    window.location.replace(`${env.authOrigin}/auth/start?ticket=${encodeURIComponent(ticket)}`);
  }, []);

  return <FullScreenLoader />;
}
